import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAuth } from "@/hooks/use-auth";
import LandingPage from "@/site/pages/landing";

// Root `/` is the logged-out marketing homepage (old app's `pages/homepage`).
// Logged-in users are sent to the card browser at /home, mirroring the old app.
// Renders the landing page immediately rather than gating on `/me` loading, since
// this is the app's most-visited, mostly-logged-out page.
function RootRoute() {
  const { user, isLoading } = useAuth();
  const { guard } = Route.useSearch();
  // Mid sign-up from the homepage premium panel (`?guard=…`): stay on the landing page so
  // its paywall can open on the picked plan — redirecting on the new session unmounted it
  // and dropped the member on /home with no paywall (legacy did the same; BDAY-177). The
  // panel itself sends them to /home once they pay, pick free, or close the paywall.
  if (!isLoading && user && guard !== "homepage-premium-benefits") return <Navigate to="/home" />;
  return <LandingPage />;
}

export const Route = createFileRoute("/")({
  validateSearch: (search: Record<string, unknown>): { guard?: string; plan?: string } => ({
    guard: typeof search.guard === "string" ? search.guard : undefined,
    plan:
      typeof search.plan === "string" && /^[a-z0-9_-]{1,40}$/i.test(search.plan)
        ? search.plan
        : undefined,
  }),
  component: RootRoute,
});
